<template>
  <div id="Case">
    <h2>四川省泸州市江阳区、合江县</h2>
    <!-- <p>Hejiang County， Jiangyang District， Luzhou City， Sichuan Province</p> -->
    <div class="case-box">
      <p>
        四川省泸州市江阳区与泸州兴阳文化教育合作，共同打造区域课后服务运营管理模式。同时邀请国内或本地教育领域知名专家，依托“清华社会治理学院”提供的课程，共同打造家长学院运营示范区，面向家长以直播讲座、直播回放、线上资源课程、现场讲座（由区域渠道组织）等方式，提升家庭子女教育育儿观，缓解家长焦虑情绪，增加社会幸福感。
      </p>
      <img src="@/assets/images/partnersCase/regionalCase_bg_6.jpg" alt="" />
      <img src="@/assets/images/partnersCase/regionalCase_bg_6_2.png" alt="" />
      <img src="@/assets/images/partnersCase/regionalCase_bg_6_1.jpg" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Case',
  metaInfo: {
    title: '伙伴与客户',
    meta: [
      { name: 'keywords', content: '晓羊集团' },
      { name: 'description', content: '' },
    ],
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  mounted() {
    //模拟触发滚动1像素，为了触发在首屏应该展示的动画（numbers动画），也能顺便返回页面顶部
    window.scrollTo(0, 1)
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
%Case {
  width: 100%;
  padding-top: 180px;
  position: relative;
  background: $--color-white;
  @include px2vw('padding-bottom', 140);
  // @include px2vw('padding-right', 240);
  text-align: center;
  h2 {
    font-size: 32px;
  }
  > p {
    font-size: 24px;
    color: #333333;
    position: relative;
    &::after {
      content: ' ';
      width: 66px;
      height: 3px;
      display: inline-block;
      position: absolute;
      left: 48%;
      margin-top: 45px;
      background: $--color-primary;
    }
  }
  .case-box {
    margin: 60px auto 0;
    width: 90%;
    max-width: 1320px;

    p {
      line-height: 32px;
      font-size: 18px;
      text-align: justify;
      color: #666;
    }
    img {
      width: 70%;
      margin-top: 80px;
    }
  }
}

.view-pc > #Case {
  @extend %Case;
  @media screen and (max-width: 1200px) {
    .case-box {
      width: 90%;
      img {
        width: 100%;
      }
    }
  }
}

.view-mobile > #Case {
  @extend %Case;
  padding-bottom: 0;
  h2 {
    font-size: 22px;
  }
  .case-box {
    width: 90%;
    margin-top: 30px !important;
    p {
      font-size: 14px;
      line-height: 28px;
      margin: 30px 0;
    }
  }
  margin-top: 44px;
  padding-top: 15px;
  > p {
    font-size: 14px;
    &::after {
      left: 42%;
      margin-top: 35px;
    }
  }
  .case-box {
    margin-top: 80px;
    img {
      width: 100%;
      margin-top: 20px;
      &:not(:first-child) {
        margin-top: 0;
        margin-bottom: 30px;
      }
    }
  }
  @media screen and (max-width: 768px) {
    > p {
      &::after {
        left: 45%;
        margin-top: 35px;
      }
    }
  }
}
</style>
